var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "couponIndicatorMain",
      attrs: { id: "popUpCouponIndicator" }
    },
    [
      _c("div", { staticClass: "\n            frame\n        " }, [
        _c(
          "div",
          {
            staticStyle: {
              width: "100%",
              display: "flex",
              "justify-content": "flex-end"
            }
          },
          [
            _c("img", {
              staticStyle: { width: "3em", height: "3em" },
              attrs: {
                src: _vm.getShopStaticResouceUrl() + "imgs/coupon/close.png"
              },
              on: { click: _vm.removeDialog }
            })
          ]
        ),
        _vm._v(" "),
        _vm.couponImg
          ? _c("img", {
              staticStyle: { width: "100%" },
              attrs: {
                src: "" + _vm.getShopStaticResouceUrl() + _vm.couponImg
              },
              on: { click: _vm.goToConsumeTicketDetail }
            })
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }